import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/api";

export const findCounter = createAsyncThunk(
  "formsubmitted/findCounter",
  async ({ form }: { form: number }, { rejectWithValue }) => {
    try {
      const url = new URL(`${api.baseURL}formsubmitted/count`);
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      const response = await fetch(url.toJSON(), {
        body: JSON.stringify({
          where: {
            form: form,
          },
        }),
        method: "POST",
        headers: headers,
      });
      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
